import { render, staticRenderFns } from "./DemoDataToggle.vue?vue&type=template&id=f7111418&scoped=true"
import script from "./DemoDataToggle.vue?vue&type=script&lang=ts"
export * from "./DemoDataToggle.vue?vue&type=script&lang=ts"
import style0 from "./DemoDataToggle.vue?vue&type=style&index=0&id=f7111418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7111418",
  null
  
)

export default component.exports